export const BASE_API_URL = process.env.REACT_APP_Demo_APP_API_URL;
export const BASE_FE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const BASE_API_AUTH_URL = process.env.REACT_APP_Auth_APP_API_URL;
export const BASE_API_URL2 = process.env.REACT_APP_Demo_APP_API_URL2;
export const BASE_API_CUST_PRIVILEGE_URL =
  process.env.REACT_APP_Auth_APP_API_CUST_PRIVIEGE;
export const BASE_API_URL3 = process.env.REACT_APP_Demo_APP_API_URL3;

// dùng để upload ảnh
export const BASE_API = process.env.REACT_APP_Pos_APP_API_URL;
//API POS
export const BASE_API_POS = process.env.REACT_APP_Pos_APP_API_URL;
//api web mới
export const BASE_API_WEB_NEW = process.env.REACT_APP_Web_New_API_URL;
export const BASE_API_CLIENT_URL = process.env.REACT_APP_API_CLIENT_URL;
